<template>
  <div class="player-setup">
    <back-button @click="goBack" />

    <app-header
      title="Spieler hinzufügen"
      subtitle="Füge mindestens 2 Spieler hinzu"
    />

    <div class="game-mode-info" v-if="selectedMode">
      <div class="game-mode-icon">
        <i :class="selectedMode.icon"></i>
      </div>
      <div>
        <div class="selected-mode">{{ selectedMode.title }}</div>
        <div class="mode-subtitle">{{ selectedMode.subtitle }}</div>
      </div>
    </div>

    <div class="player-list" v-if="players.length > 0">
      <player-item
        v-for="(player, index) in players"
        :key="index"
        :player="player"
        @remove="removePlayer(index)"
      />
    </div>

    <add-player-form @add-player="addPlayer" @invalid-input="setError" />

    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

    <app-button
      :is-pulsing="canStartGame"
      :is-disabled="!canStartGame"
      @click="startGame"
    >
      Spiel starten
    </app-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BackButton from "@/components/UI/BackButton.vue";
import AppHeader from "@/components/UI/AppHeader.vue";
import AppButton from "@/components/UI/AppButton.vue";
import PlayerItem from "@/components/PlayerItem.vue";
import AddPlayerForm from "@/components/AddPlayerForm.vue";

export default {
  name: "PlayerSetup",
  components: {
    BackButton,
    AppHeader,
    AppButton,
    PlayerItem,
    AddPlayerForm,
  },
  data() {
    return {
      errorMessage: "",
    };
  },
  computed: {
    ...mapGetters({
      selectedMode: "getSelectedMode",
      players: "getPlayers",
      canStartGame: "canStartGame",
    }),
  },
  methods: {
    ...mapActions(["addPlayer", "removePlayer"]),
    goBack() {
      this.$router.push("/");
    },
    startGame() {
      if (this.canStartGame) {
        this.$router.push("/game");
      } else {
        this.setError("Du benötigst mindestens 2 Spieler.");
      }
    },
    setError(message) {
      this.errorMessage = message;

      // Clear error message after 3 seconds
      setTimeout(() => {
        this.errorMessage = "";
      }, 3000);
    },
  },
};
</script>

<style scoped>
.player-setup {
  position: relative;
  padding-top: var(--spacing-lg);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.game-mode-info {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
  background-color: var(--secondary-bg);
  padding: var(--spacing-md);
  border-radius: var(--border-radius-md);
}

.game-mode-icon {
  font-size: var(--font-size-xl);
  color: var(--accent-color);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 224, 208, 0.1);
  border-radius: var(--border-radius-md);
}

.selected-mode {
  font-weight: 600;
}

.player-list {
  margin: var(--spacing-lg) 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.error-message {
  color: var(--error-color);
  text-align: center;
  margin-top: var(--spacing-sm);
  font-size: var(--font-size-sm);
}
</style>
